export enum QueryKey {
    CLAIM = 'claim',
}